import React from 'react';
import { Reveal } from '../components/motion/Reveal';
import { usePageMeta } from '../hooks/usePageMeta';
import { PageHero } from '../components/ui/PageHero';
import { CallToAction } from '../components/ui/CallToAction';
import { services } from '../data/services';
export function Services() {
  usePageMeta('Our Services | Avenqor Talent Search', 'Executive search, board and non-executive director search, leadership talent mapping, specialized recruitment, candidate sourcing and talent advisory.');
  return <>
      <PageHero eyebrow="Our Services" title="Search and advisory for senior and specialist appointments." intro="Six services, each designed to answer a different hiring question — from filling a single executive role to understanding an entire leadership market." data-id="element-542" data-mp="3t9e7r3hypyuz" />

      <nav aria-label="Services on this page" className="border-b border-line bg-paper" data-id="element-543" data-mp="2cvo23sb732j8">
        <ul className="mx-auto flex max-w-7xl gap-x-8 gap-y-3 overflow-x-auto px-5 py-5 sm:px-8 lg:flex-wrap" data-id="element-544" data-mp="27xvza390hw09">
          {services.map(service => <li key={service.id} className="shrink-0" data-id="element-545" data-mp="1bnnxcg3o0ls1">
              <a href={`#${service.id}`} className="whitespace-nowrap text-sm text-muted transition-colors duration-150 ease-out hover:text-navy" data-id="element-546" data-mp="1bo5s18aoirxu">
                {service.title}
              </a>
            </li>)}
        </ul>
      </nav>

      <div className="bg-white" data-id="element-547" data-mp="1pestv9bqkxy5">
        <div className="mx-auto max-w-7xl px-5 sm:px-8" data-id="element-548" data-mp="1uef214cpjo03">
          {services.map((service, index) => {
          const Icon = service.icon;
          return <Reveal as="section" key={service.id} id={service.id} aria-labelledby={`${service.id}-title`} className={`grid scroll-mt-24 gap-10 py-20 lg:grid-cols-12 lg:gap-12 lg:py-24 ${index > 0 ? 'border-t border-line' : ''}`} data-id="element-549" data-mp="1ze9tb90eaflo" data-mpi={index}>
                <div className="lg:col-span-5" data-id="element-550" data-mp="1cb6pmngj0xvs">
                  <span className="flex h-12 w-12 items-center justify-center border border-gold/60 text-gold-deep" data-id="element-551" data-mp="1ce2nycwadokr">
                    <Icon className="h-5 w-5" strokeWidth={1.5} aria-hidden="true" data-id="element-552" data-mp="1lcoccoofvxtg" />
                  </span>
                  <h2 id={`${service.id}-title`} className="mt-7 font-serif text-[2.25rem] font-medium leading-[1.1] text-navy sm:text-[2.6rem]" data-id="element-553" data-mp="1hbb3s6typgiu">
                    {service.title}
                  </h2>
                  <p className="mt-4 text-[17px] leading-relaxed text-ink" data-id="element-554" data-mp="1q9n5b3wd9yq2">{service.summary}</p>
                </div>
                <div className="lg:col-span-7" data-id="element-555" data-mp="201khacv78upu">
                  <p className="text-[17px] leading-relaxed text-muted" data-id="element-556" data-mp="202vkobkqg0gf">{service.overview}</p>
                  <h3 className="mt-10 text-sm font-semibold text-navy" data-id="element-557" data-mp="2e2dckztbrtu0">What this typically involves</h3>
                  <ul className="mt-4 grid gap-x-8 gap-y-3 sm:grid-cols-2" data-id="element-558" data-mp="293jz37e1g2tu">
                    {service.involves.map(item => <li key={item} className="flex gap-3 text-[15px] leading-relaxed text-ink" data-id="element-559" data-mp="2slxyxes4w0xl">
                        <span aria-hidden="true" className="mt-[11px] h-px w-3 shrink-0 bg-gold-deep" data-id="element-560" data-mp="2xl14r1fxub6m" />
                        {item}
                      </li>)}
                  </ul>
                  <p className="mt-10 border-l-2 border-gold pl-5 text-[15px] leading-relaxed text-ink" data-id="element-561" data-mp="2nqsgipxxx4e9">
                    <span className="font-semibold text-navy" data-id="element-562" data-mp="29vq4rm6ewktj">Suited to: </span>
                    {service.suitedTo}
                  </p>
                </div>
              </Reveal>;
        })}
        </div>
      </div>

      <CallToAction title="Not sure which service fits?" text="Many engagements begin with a conversation about the problem rather than the service. Tell us what you are trying to achieve and we will suggest an approach." data-id="element-563" data-mp="24xok4wtc8dfy" />
    </>;
}